<template>
  <div class="container mobcon">
    <h2 class="mt-5 text-center">Election Dashboard</h2>
    <v-data-table 
       :headers="headers" 
       :mobile-breakpoint="0" 
       :items="dataWithIndex"   
       :single-expand="singleExpand" 
       :expanded.sync="expanded" 
       hide-default-footer  
       class="playertable">
       <template v-slot:item="{ item,index,expand,isExpanded }"  >
        <tr>
          <td class="text-left">{{ index+1 }}  </td>
          <td class="text-left">{{ item.name }} </td>
          <td class="text-center makeitflex">
             <div><v-btn v-if="item.template_created == 0" class="mr-2" :to="getUrl(item.url)" color="primary">Create Election</v-btn></div>
             <div><v-btn color="secondary" @click="expand(!isExpanded); getUnitsData(item,isExpanded,index)" class="actions bigbtn">See Result</v-btn></div>
             <div class="ml-1"><v-btn class="white--text"  color="#666666" @click="getCertificate(item.id)">&nbsp;  &nbsp;Certificate &nbsp; &nbsp;</v-btn></div>
          </td>
        </tr>
        
      </template>      
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length" class="customtd">
          <div v-if="showloader" class="text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div>
            <v-expansion-panels class="myexpansion">
              <template> 
                <v-expansion-panel v-for="(val,key) in item.units" :disabled="val.electionCompleted == 0" :key="key">
                  <v-expansion-panel-header>
                     <div class="d-flex myflex flexmob">
                       <div><span v-if="val.showheader == 1">{{ val.template_name }} </span></div>
                       <div>Votes / Voters:- &nbsp; {{ val.totalvotes }} / {{val.totalvoters }}</div>
                       <div>% of Votes Counted:- &nbsp; {{ val.votespercentage }}% </div>
                       <div><v-btn color="gray"  @click="downloadReport(val.election, val.sub)">Voter Report</v-btn> </div>
                     </div>
                     
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                  
                     <div class="candidates" v-for="(inval,inkey) in val.candidates" :key=inkey>
                        <div class="firstblock">
                          <div class="logo" v-if="inval.logo"><img :src=inval.logo /></div>
                            <div>
                              <div>{{ inval.lastname }} {{ inval.firstname }}</div>
                              <div class="party">{{ inval.party }}</div>
                            </div>
                        </div>
                        <div class="secondblock">
                          <div>
                            <div class="text-center">Votes : {{ inval.votes }}</div>
                            <v-progress-linear v-if="!showOverallPercentage" color="orange" rounded :value=getvalue(inval.overallpercentage) height="15">
                             <span class="progress-bar-txt">{{ getvalue(inval.overallpercentage) }}%</span>
                            </v-progress-linear>
                            <v-progress-linear v-if="showOverallPercentage" color="orange" rounded :value=getvalue(inval.percentage) height="15">
                              <span class="progress-bar-txt">{{ getvalue(inval.percentage) }}%</span>
                             </v-progress-linear>
                        </div> 
                       
                        </div>
                     </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
             </v-expansion-panels> 
          </div>
        </td>
        
     </template>     
    </v-data-table>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-text>{{ dialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="certdialog"
      max-width="800px"
    ><v-card>
        <v-card-title class="text-h5 primary white--text">
          Certificate of Election
        </v-card-title>

        <v-card-text>
          <div class="pa-4">
            <v-text-field label="Certificate No/ UNIQUE ID" name="name"  outlined type="text" v-model="certnumber"/>
          </div>
          <div v-if="notfoundCert" class="error-message">Certificate not found.</div>
          <div v-if="pdfUrl != ''">
             <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary" @click="searchCertificate"
          >
            Search
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div> 
</template>
<script>
import axios from 'axios';
export default{
  name: 'Electionlisting',
  data(){
    return{
       data:[],
       dialog: false,
       dialogTitle: '',
       dialogMessage: '',
       singleExpand: true,
       showloader:false,
       expanded: [],
       certdialog:false,
       showOverallPercentage: true,
       certnumber:'',
       electionId:0,
       pdfUrl:'',
       notfoundCert:false,
       headers:[
                  { text:"S.No",value: "",sortable: true, width:"8%"},
                  { text:"Election Name",value:"",sortable:false, width:"62%"},
                  { text:"Action", value: "",sortable: false, width:"20%"},
               ],
    }
  },
  mounted()
  {
     this.$store.dispatch("getmyelections").then((response) => 
     {
         if(response.status)
         {
           this.data = response.data;
         }
     });
  },
  computed: {
    dataWithIndex() 
    {  
      return this.data.map((items, index) => ({ ...items, index: index + 1 }));
    },
  },
  methods:{
    /*
    change(index,key){
      console.log(this.dataWithIndex[index].units[key].candidates);
      console.log(key);
    },
    */
    getCertificate(id){
      this.electionId = id;
      this.certdialog = true;
      this.notfoundCert = false;
      this.pdfUrl = '';
    },
    getvalue(changed){
        return changed;
    },
    getUrl(url){
      return "/election-dashboard/"+url;
    },
    searchCertificate()
    {
      this.notfoundCert = false;
      this.pdfUrl = '';
      this.$store.dispatch("findCertificate", { certnumber: this.certnumber, electionId: this.electionId }).then(({data})=>{
        if(data.status)
        {
           this.pdfUrl = data.data;
        }
        else
        {
           this.notfoundCert = true;
        }
      })
    },
    getUnitsData(item,isExpanded,index){
      if(!isExpanded)
      {
        this.showloader = true;
        this.$store.dispatch("getElectionData",{eid:item.id}).then((response) => 
        {
          this.data[index].units = response.data;
          this.showloader = false;
        });  
      }
     },
     async downloadReport(blockchainId, suburb) {
      try {
        const response = await axios.get(`/download-report/${blockchainId}/${suburb}`, {
          responseType: 'blob',
          validateStatus: status => status < 500 // allow custom handling of 404
        });

        if (response.status === 404) {
          this.dialogTitle = 'File Not Ready';
          this.dialogMessage = response.data.message || 'The report is not yet available.';
          this.dialog = true;
          return;
        }

        // File exists, trigger download
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${suburb}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.dialogTitle = 'Error';
        this.dialogMessage = 'Something went wrong while downloading the report.';
        this.dialog = true;
      }
    }
  }
}  
</script>
<style scoped>
.candidates {display: flex; margin-bottom: 10px;}
.candidates > div.firstblock{margin-right: 5px; flex: 0 0 50%;}
.candidates > div.secondblock{margin-right: 5px; flex: 0 0 50%;}
.candidates > div {display: flex;}
.candidates > div > div.logo{flex: 0 0 10%;}
.candidates > div img{width: 45px;    height: 45px;}
.candidates  div.secondblock > div{flex: 1; margin-right: 10px;}
.party{font-size: 13px;}
.myflex.flexmob{align-items: center;}
.myflex{flex:1;justify-content: space-between;}
/*.myflex > div:nth-child(2){margin-right: 20px;}*/
.myflex > div{width: 25%; text-align: center;}
.myflex > div:nth-child(2){text-align: center;}
.myflex > div:nth-child(3){text-align: right; margin-right: 20px;}
.bigbtn{width: 170px;}
.makeitflex{ display: flex;  align-items: center;}
.mobcon{padding: 0;}
@media(max-width:768px)
{
   .makeitflex{display: block;height: inherit !important;}
   .makeitflex div{margin-top: 5px;margin-bottom: 5px;}
   .actions.ml-5{margin-left: 0 !important;}
   .bigbtn{width: 170px;}
}  
@media(max-width:767px)
{
  .candidates  div.secondblock{  display: block;  text-align: center;}
  .candidates  div.secondblock > div{margin-bottom: 5px;}
  .candidates > div{margin-right: 5px; flex: 0 0 60%;}
  .candidates div.secondblock{    flex: 0 0 40% !important;}
  .myflex.flexmob{display: block !important;}
  .myflex > div{ width: 100%; text-align: left !important; margin-bottom: 5px;}
  .candidates > div > div.logo{margin-right: 7px;}
}  
</style>
<style>
@media(max-width:767px)
{
.myexpansion .v-expansion-panel-content__wrap{padding: 0 10px 16px;}
}
</style>